<template>
    <div class="bg-red-300 text-gray-900 rounded p-2 text-sm" v-if="isImpersonating">
        <div>
            <code>{{ sessionExpired ? "00:00" : sessionTime }}</code> |
            <span v-if="sessionExpired">Session expired</span>
            <span v-else>
                Impersonating: <strong>{{ userImpSession.userEmail }}</strong>
            </span>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "cImpSession",
    data() {
        return {
            secondsLeft: 1,
        };
    },
    computed: {
        ...mapState(["userImpSession"]),
        isImpersonating() {
            return Object.keys(this.userImpSession).length > 0;
        },
        sessionTime() {
            const minutes = String(Math.floor(this.secondsLeft / 60)).padStart(2, "0");
            const seconds = String(this.secondsLeft - minutes * 60).padStart(2, "0");
            return `${minutes}:${seconds}`;
        },
        sessionExpired() {
            return this.secondsLeft <= 0;
        },
    },
    methods: {
        startTimer() {
            this.endTimer();
            this.countSecondsLeft();
            this.counter = setInterval(() => this.countSecondsLeft(), 1000);
        },
        endTimer() {
            clearInterval(this.counter);
        },
        countSecondsLeft() {
            this.secondsLeft = Math.floor(
                (new Date(this.userImpSession.validTo).getTime() - Date.now()) / 1000
            );
            if (this.sessionExpired) {
                this.endTimer();
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            }
        },
    },
    beforeUnmount() {
        this.endTimer();
    },
    watch: {
        isImpersonating: {
            handler(value) {
                if (value) {
                    this.startTimer();
                } else {
                    this.endTimer();
                }
            },
            immediate: true,
        },
    },
};
</script>
